// extracted by mini-css-extract-plugin
export default {"header":"MainAppBar_header__ClVSp","logo":"MainAppBar_logo__rV99C","environment":"MainAppBar_environment__VgNc8","link":"MainAppBar_link__ekFRd"};